export default __webpack_public_path__ + "4cc7f2c9aa99f76090174c17b75400ee.png";